import { useRef, useState, useEffect } from "react";
import Carousel, { consts } from "react-elastic-carousel";
import CircleButton from "../components/CircleButton";
import Person from "components/Person";

export default function CasePeople({ casePeopleRecords }) {
  // Carousel states
  const [nextEnabled, setNextEnabled] = useState(true);
  const [prevEnabled, setPrevEnabled] = useState(true);
  const carouselRef = useRef();

  // Handles arrow enabling/disabling on resize and slide
  const setCarouselArrows = (future = false) => {
    const adjust = future ? 1 : 0;
    const activeIndex = carouselRef.current.state.activeIndex;
    const canSlidePrev =
      activeIndex !==
      carouselRef.current.getNextItemIndex(activeIndex - adjust, true);
    const canSlideNext =
      activeIndex !==
      carouselRef.current.getNextItemIndex(activeIndex + adjust, false);
    setNextEnabled(canSlideNext);
    setPrevEnabled(canSlidePrev);
  };

  // Sets the initial arrows
  useEffect(() => {
    const { children, itemsToShow } =
      carouselRef.current.getDerivedPropsFromBreakPoint();
    setNextEnabled(children.length > itemsToShow);
  }, []);

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 600, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1024, itemsToShow: 4 },
  ];

  const handleResize = () => {
    setCarouselArrows();
  };

  const handleSlideNext = () => {
    carouselRef.current.slideNext();
    setCarouselArrows(true);
  };

  const handleSlidePrevious = () => {
    carouselRef.current.slidePrev();
    setCarouselArrows(true);
  };

  const handleOnChange = () => {
    setCarouselArrows();
  };

  return (
    <section className="max-w-6xl	mx-auto pt-14 px-4 xl:px-0">
      <header className="relative flex">
        <h2 className="highlight">Important People</h2>
        <div className="flex absolute right-0 top-0">
          <CircleButton
            disabled={!prevEnabled}
            text="slide left"
            onClick={handleSlidePrevious}
          />
          <CircleButton
            disabled={!nextEnabled}
            className="ml-2.5"
            direction="right"
            text="slide right"
            onClick={handleSlideNext}
          />
        </div>
      </header>
      <Carousel
        outerSpacing={-8}
        itemPadding={[0, 1]}
        itemPosition={consts.START}
        itemsToShow={3}
        ref={carouselRef}
        breakPoints={breakPoints}
        showArrows={false}
        pagination={false}
        className="flex mt-4 -mx-1.5"
        onResize={handleResize}
        onChange={handleOnChange}
        showEmptySlots
        preventDefaultTouchmoveEvent
      >
        {casePeopleRecords.map(
          ({
            date_of_birth,
            deathDate,
            description_text,
            first_name,
            images,
            last_name,
            notes,
            relationship,
          }) => {
            // TODO: swap for a photo_item_id
            const photoUrl = images.length > 0 ? images[0].url : null;
            return (
              <Person
                birthDate={date_of_birth}
                deathDate={deathDate}
                description={description_text}
                key={`${first_name} ${last_name}`}
                firstName={first_name}
                lastName={last_name}
                notes={notes}
                photoUrl={photoUrl}
                relationship={relationship}
              />
            );
          }
        )}
      </Carousel>
    </section>
  );
}
